import client from './ApiClient';

function getSkills(query) {
  return client(`v1/behaviors`, { method: 'GET', params: query });
}

export { getSkills };
